<!--
 * @Author: 张天昊
 * @Date: 2024-05-22 10:56:41
 * @LastEditTime: 2024-06-05 11:04:40
 * @LastEditors: 张天昊
 * @Description: 景区卡片
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/ScenicCard.vue
-->
<script>
import { defineComponent, ref, computed } from 'vue';
import CardContainer from './CardContainer.vue';
import Description from './Description.vue';
import WithLink from './WithLink.vue';
import { navigateToTouristsView } from '../navigate';

export default defineComponent({
  components: {
    CardContainer,
    Description,
    WithLink
  },
  props: {
    data: {
      // {
      //   title: '洱海生态廊道',
      //   playtime: '2024/04/25 上午',
      //   tourists: string[],
      //   location: '古城区'
      // }[]
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    function handleNavigateToTouristsView(index) {
      const tourists = props.data[index].tourists;
      navigateToTouristsView(tourists, '景区参团游客');
    }
    return {
      handleNavigateToTouristsView
    };
  }
});
</script>

<template>
  <CardContainer>
    <van-steps
      v-if="data.length"
      :active="Number.NEGATIVE_INFINITY"
      class="custom-steps-style-a -my-11"
      direction="vertical"
    >
      <van-step
        v-for="(item, index) in data"
        :key="item.title"
        class="custom-step-style-a"
      >
        <template #inactive-icon>
          <div class="custom-step-dot-style-a"></div>
        </template>
        <div class="text-16 leading-20 text-black-a font-semibold break-all">
          {{ item.title }}
        </div>
        <div
          v-if="item.location"
          class="mt-6 text-14 leading-17 text-grey-b flex items-center"
        >
          <svg-icon
            pre-path="itineraryUniversal"
            name="ic-location"
            class="w-12 h-12 mr-3"
          />{{ item.location }}
        </div>
        <Description class="mt-8" label="游玩时间" :content="item.playtime" />
        <Description class="mt-4" label="景区参团游客数">
          <WithLink
            gutter
            class="text-black-a"
            @click="handleNavigateToTouristsView(index)"
            >{{ item.tourists.length }}人</WithLink
          >
        </Description>
      </van-step>
    </van-steps>
  </CardContainer>
</template>

<style scoped>
.custom-steps-style-a {
  --custom-step-gutter: 22px;
  --custom-step-circle-top: 16px;
}
</style>
